import React from 'react';

export default({style}) =>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 viewBox="0 0 97.000000 55.000000"
 preserveAspectRatio="xMidYMid meet" style={style}>
    <g transform="translate(0.000000,68.000000) scale(0.050000,-0.050000)" stroke="none">
    <path d="M670 1199 c-167 -47 -249 -84 -324 -147 -31 -25 -76 -57 -101 -70
    -47 -25 -64 -128 -25 -152 33 -20 23 -40 -40 -77 -71 -42 -76 -79 -17 -121 38
    -26 40 -35 16 -64 -39 -46 90 -157 230 -199 500 -149 1102 -35 1244 237 18 35
    51 60 88 67 87 18 86 120 -1 153 -33 13 -65 39 -71 58 -18 56 -230 233 -343
    287 -149 71 -458 84 -656 28z m625 -315 c114 -41 165 -74 85 -55 -107 25 -761
    -63 -949 -127 -265 -92 -278 -15 -21 121 44 23 85 49 90 57 45 65 619 68 795
    4z"/>
    </g>
</svg>
